export enum FontLoadStatus {
  BeforeLoad = 'before_load',
  Success = 'success',
  Fail = 'fail',
}
